import { cn } from '@/lib/utils'
import { ToggleGroup, ToggleGroupItem } from './ui'

export interface ToggleOption<TValue extends string> {
  value: TValue
  label: string
}

interface Props<TValue extends string> {
  className?: string

  value: TValue
  options: ToggleOption<TValue>[]

  wide?: boolean
  clearable?: boolean

  onChange(value: TValue): void
}

export function Toggles<TValue extends string>({
  className,

  value,
  options,

  wide = false,
  clearable = false,

  onChange,
}: Props<TValue>) {
  function handleChange(val: TValue) {
    if (!clearable && !val) return
    onChange(val)
  }

  return (
    <ToggleGroup
      className={cn(className, wide && 'w-full grid grid-flow-col')}
      type="single"
      variant="outline"
      value={value}
      onValueChange={handleChange}
    >
      {options.map(toggle => (
        <ToggleGroupItem key={toggle.value} value={toggle.value}>
          {toggle.label}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  )
}
